import { render, staticRenderFns } from "./ticketVoucherDetail.vue?vue&type=template&id=8a4b7b3c&lang=pug"
import script from "./ticketVoucherDetail.vue?vue&type=script&lang=js"
export * from "./ticketVoucherDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports